export const MOBILE_BREAKPOINT_PX = 768;

export const breakpoints = {
    smallMin: `min-width: 48em`,
    mediumMin: `min-width: 64em`,
};
